import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/contexts/LanguageContext";
import HomePage from "@/pages/HomePage";
import BookingConfirmation from "@/pages/BookingConfirmation";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminSettings from "@/pages/AdminSettings";

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <div className="App">
          <BrowserRouter>

            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/booking/:bookingId" element={<BookingConfirmation />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/admin/settings" element={<AdminSettings />} />
            </Routes>
          </BrowserRouter>
          <Toaster richColors position="top-right" />
        </div>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
